export default "__VITE_ASSET__BuKBSQUS__"